import { ApiP2MetricsResponse, P2Metrics } from "@/core/dashboard/entities/P2Metrics";
import { toColorIndicator } from "./colorIndicatorMapper";

/**
 * Maps GET /api/v1/dashboard/agence/p2/metrics to the P2Metrics domain model.
 */
export default class P2MetricsMapper {
  static toDomain(api: ApiP2MetricsResponse): P2Metrics {
    return {
      branchAccountOpeningSla: {
        avgDays: api.branchAccountOpeningSla?.avgDays ?? null,
        totalAccounts: api.branchAccountOpeningSla?.totalAccounts ?? 0,
        colorIndicator: toColorIndicator(
          api.branchAccountOpeningSla?.colorIndicator,
        ),
      },
      documentRejectionRate: {
        value: api.documentRejectionRate?.value ?? null,
        rejectedCount: api.documentRejectionRate?.rejectedCount ?? 0,
        totalCount: api.documentRejectionRate?.totalCount ?? 0,
        colorIndicator: toColorIndicator(
          api.documentRejectionRate?.colorIndicator,
        ),
      },
      commercialVolume: api.commercialVolume ?? null,
      rekycBacklog: {
        overdue: api.rekycBacklog?.overdue ?? null,
        dueSoon: api.rekycBacklog?.dueSoon ?? null,
        total: api.rekycBacklog?.total ?? null,
        available: api.rekycBacklog?.available ?? false,
      },
    };
  }
}
